import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const play: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M10.813-4.766.438 1.016q-.175.092-.313.015Q-.002.95 0 .75v-11.5q-.001-.2.125-.281c.094-.051.195-.047.313.015L10.813-5.25Q11-5.14 11-5t-.187.234m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11.066)"
    />
  ),
  svgProps: {
    height: "12.132",
    width: "11",
  }
};
